
import { Button, TextField, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import MultiSelect from "./MultiSelect";
import { MilestoneContentProps } from "./type";
export default function MilestoneContent({
  activeTab,
  milestones,
  handleTabChange,
  addMilestone,
  removeMilestone,
  handleMilestoneChange,
  parentType,
}: MilestoneContentProps) {
  const primaryDarkTeal = "#ffb310";
  const primaryLightBlue = "#ffb310";
  const inputBackground = "#F0F0F0";

  const activeColor = parentType === "air" ? primaryDarkTeal : primaryLightBlue;
  
  return (
    <>
      <div className="flex space-x-0.5 mb-5 border-b border-yellow-500 pb-0">
        <Button
          onClick={() => handleTabChange("first-mile")}
          sx={{
            px: 3,
            py: 1,
            fontSize: "0.900rem",
            fontWeight: 600,
            borderRadius: "0.375rem 0.375rem 0 0",
            borderBottom:
              activeTab === "first-mile"
                ? "2px solid #ffb310"
                : "2px solid transparent",
            backgroundColor:
              activeTab === "first-mile" ? "#fff" : "#fff",
            color: activeTab === "first-mile" ? "#ffb310" : "#4B5563",
            "&:hover": {
              backgroundColor:
                activeTab === "first-mile" ? "#fff" : "#fff",
            },
            textTransform: "none",
          }}
        >
          First Mile
        </Button>
        <Button
          onClick={() => handleTabChange("middle-mile")}
          sx={{
            px: 3,
            py: 1,
            fontSize: "0.900rem",
            fontWeight: 600,
            borderRadius: "0.375rem 0.375rem 0 0",
            borderBottom:
              activeTab === "middle-mile"
                ? "2px solid #ffb310"
                : "2px solid transparent",
            backgroundColor:
              activeTab === "middle-mile" ? "#fff" : "#fff",
            color: activeTab === "middle-mile" ? "#ffb310" : "#4B5563",
            "&:hover": {
              backgroundColor:
                activeTab === "middle-mile" ? "#fff" : "#fff",
            },
            textTransform: "none",
          }}
        >
          Middle Mile
        </Button>
        <Button
          onClick={() => handleTabChange("last-mile")}
          sx={{
            px: 3,
            py: 1,
            fontSize: "0.900rem",
            fontWeight: 600,
            borderRadius: "0.375rem 0.375rem 0 0",
            borderBottom:
              activeTab === "last-mile"
                ? "2px solid #ffb310"
                : "2px solid transparent",
            backgroundColor:
              activeTab === "last-mile" ? "#fff" : "#fff",
            color: activeTab === "last-mile" ? "#ffb310" : "#4B5563",
            "&:hover": {
              backgroundColor:
                activeTab === "last-mile" ? "#fff" : "#fff",
            },
            textTransform: "none",
          }}
        >
          Last Mile
        </Button>
      </div>


      <div className="mt-5 space-y-4">
        {activeTab == "first-mile" || activeTab == "last-mile" ? (
          <div className="sticky top-0 z-10 bg-gray-50 bgHead border-b border-gray-200">
            <div className="grid grid-cols-12 gap-1 sm:gap-4 items-center py-1">

              <div className="col-span-5 sm:col-span-3 lg:col-span-3">
                <div className="h-[40px] px-3 flex items-center text-sm font-semibold text-gray-600 tracking-wide">
                  Milestone Name
                </div>
              </div>

              <div className="col-span-5 sm:col-span-3 lg:col-span-3">
                <div className="h-[40px] px-3 flex items-center text-sm font-semibold text-gray-600 tracking-wide">
                  Description
                </div>
              </div>

              <div className="col-span-4 sm:col-span-3">
                <div className="h-[40px] px-3 flex items-center text-sm font-semibold text-gray-600 tracking-wide">
                  Ground Staff
                </div>
              </div>
              <div className="col-span-4 sm:col-span-3">
                <div className="h-[40px] px-3 flex items-center text-sm font-semibold text-gray-600 tracking-wide">
                  Actions
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {milestones.map((milestone, index) => {


          const isLastRow = index === milestones.length - 1;

          return (
            <div
              key={milestone.id}
              className="grid grid-cols-12 gap-1 sm:gap-4 items-center mt-2"
            >
              {activeTab === "first-mile" || activeTab === "last-mile" ? (
                <>
                  <div className="col-span-5 sm:col-span-3 lg:col-span-3">
                    <TextField
                      className="input-milestone"
                      variant="outlined"
                      size="small"
                      placeholder="Milestone Name"
                      value={milestone.name}
                      onChange={(e) =>
                        handleMilestoneChange(milestone.id, "name", e.target.value,activeTab)
                      }
                      InputProps={{
                        sx: {
                          backgroundColor: inputBackground,
                          border: "none",
                          "& fieldset": { border: "none" },
                          "&:hover fieldset": { border: "none" },
                          "&.Mui-focused fieldset": { border: "none" },
                        },
                      }}
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "8px 12px",
                        },
                      }}
                    />
                  </div>
                  <div className="col-span-5 sm:col-span-3 lg:col-span-3">

                    <TextField
                      className="input-milestone"
                      variant="outlined"
                      size="small"
                      placeholder="Description"
                      value={milestone.description}
                      onChange={(e) =>
                        handleMilestoneChange(
                          milestone.id,
                          "description",
                          e.target.value,
                          activeTab
                        )
                      }
                      InputProps={{
                        sx: {
                          backgroundColor: inputBackground,
                          border: "none",
                          "& fieldset": { border: "none" },
                          "&:hover fieldset": { border: "none" },
                          "&.Mui-focused fieldset": { border: "none" },
                        },
                      }}
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "8px 12px",
                          width: "100%"
                        },
                      }}
                    />
                  </div>

                  <div className="col-span-4 sm:col-span-3">
                    <div className="select_drop_milestone">
                      <MultiSelect
                        
                        options={milestone.groundStaffOptions || []}
                        value={(milestone.groundStaffOptions || []).filter((ele) => (milestone.groundStaffIds?.includes(ele.value)))}

                        onChange={(selected) =>
                          handleMilestoneChange(
                            milestone.id,
                            "groundStaffIds",
                            selected.map(s => s.value) as any,
                            activeTab
                          )
                        }
                        placeholder="Select Ground Staff"
                      />
                    </div>
                  </div>
                </>

              ) : null}

              <div className="col-span-2 sm:col-span-3 lg:col-span-3">
                <div className="iconMilestone">
                  {activeTab !== "middle-mile" &&
                    (index==0 ? (
                      <>
                        <IconButton className="iconMilestone_plus" onClick={addMilestone} sx={{ color: "#4B5563" }}>
                          <AddIcon />
                        </IconButton>
                        {milestones.length>1&&<IconButton className="iconMilestone_close"
                          onClick={() => removeMilestone(milestone.id)}
                          sx={{ color: "#4B5563" }}
                        >
                          <CloseIcon />
                        </IconButton>}
                      </>

                    ) : (
                      <IconButton
                        className="iconMilestone_close"
                        onClick={() => removeMilestone(milestone.id)}
                        sx={{ color: "#4B5563" }}
                      >
                        <CloseIcon />
                      </IconButton>
                    ))}

                </div>
              </div>
            </div>)
        })}
      </div>
    </>
  );
}
